import { Store } from "pullstate";


export const PlanStore = new Store({
   plan:null
  });

